export default "__VITE_ASSET__BlgCKMHY__"